import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppConfig } from "../../../config";
import { EmployeeRoom } from "../../../model/api/administration/employee-room";
import { EmployeeRoomAdd } from "../../../model/api/assets/employee-room-add";
import { GenericHttpService } from "../generic.http.service";


@Injectable()
export class EmployeeRoomHttpService extends GenericHttpService<EmployeeRoom, number> {
    constructor(public http: HttpClient) {
        super(http, "", "employeerooms");
    }

    public addRoomByEmployee(reco: EmployeeRoomAdd): Observable<any> {
        // return super.create(reco, 'reco')
        return this.http.post(AppConfig.urlPrefix + this.url + '/add', reco, { headers: this.headers }).pipe(
        map((data: Response) => {
            return data;
        }));
    }

    public deleteEmployeeRoom(id: number): Observable<any> {
        return this.http.delete(AppConfig.urlPrefix + this.url + '/remove' + `/${id}`).pipe(
        map((data: Response) => {
            return data;
        }));
    }
}
